/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightExchangeAuthenticationAction } from "./FlightExchangeAuthenticationAction";
import {
  FlightExchangeAuthenticationActionFromJSON,
  FlightExchangeAuthenticationActionFromJSONTyped,
  FlightExchangeAuthenticationActionToJSON,
  FlightExchangeAuthenticationActionToJSONTyped,
} from "./FlightExchangeAuthenticationAction";

/**
 *
 * @export
 * @interface FlightExchangeAuthenticationResponse
 */
export interface FlightExchangeAuthenticationResponse {
  /**
   *
   * @type {string}
   * @memberof FlightExchangeAuthenticationResponse
   */
  exchangeId: string;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeAuthenticationResponse
   */
  authenticationId: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeAuthenticationResponse
   */
  provider: string;
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangeAuthenticationResponse
   */
  test: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeAuthenticationResponse
   */
  status: FlightExchangeAuthenticationResponseStatusEnum;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeAuthenticationResponse
   */
  reasonCode: string;
  /**
   *
   * @type {Date}
   * @memberof FlightExchangeAuthenticationResponse
   */
  expiresAt: Date | null;
  /**
   *
   * @type {FlightExchangeAuthenticationAction}
   * @memberof FlightExchangeAuthenticationResponse
   */
  action: FlightExchangeAuthenticationAction | null;
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangeAuthenticationResponse
   */
  canConfirm: boolean;
}

/**
 * @export
 */
export const FlightExchangeAuthenticationResponseStatusEnum = {
  Unavailable: "unavailable",
  Pending: "pending",
  ActionRequired: "action_required",
  Authenticated: "authenticated",
  Failed: "failed",
  Expired: "expired",
  NeedsAttention: "needs_attention",
} as const;
export type FlightExchangeAuthenticationResponseStatusEnum =
  (typeof FlightExchangeAuthenticationResponseStatusEnum)[keyof typeof FlightExchangeAuthenticationResponseStatusEnum];

/**
 * Check if a given object implements the FlightExchangeAuthenticationResponse interface.
 */
export function instanceOfFlightExchangeAuthenticationResponse(
  value: object
): value is FlightExchangeAuthenticationResponse {
  if (!("exchangeId" in value) || value["exchangeId"] === undefined)
    return false;
  if (!("authenticationId" in value) || value["authenticationId"] === undefined)
    return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("test" in value) || value["test"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("reasonCode" in value) || value["reasonCode"] === undefined)
    return false;
  if (!("expiresAt" in value) || value["expiresAt"] === undefined) return false;
  if (!("action" in value) || value["action"] === undefined) return false;
  if (!("canConfirm" in value) || value["canConfirm"] === undefined)
    return false;
  return true;
}

export function FlightExchangeAuthenticationResponseFromJSON(
  json: any
): FlightExchangeAuthenticationResponse {
  return FlightExchangeAuthenticationResponseFromJSONTyped(json, false);
}

export function FlightExchangeAuthenticationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangeAuthenticationResponse {
  if (json == null) {
    return json;
  }
  return {
    exchangeId: json["exchange_id"],
    authenticationId: json["authentication_id"],
    provider: json["provider"],
    test: json["test"],
    status: json["status"],
    reasonCode: json["reason_code"],
    expiresAt: json["expires_at"] == null ? null : new Date(json["expires_at"]),
    action: FlightExchangeAuthenticationActionFromJSON(json["action"]),
    canConfirm: json["can_confirm"],
  };
}

export function FlightExchangeAuthenticationResponseToJSON(
  json: any
): FlightExchangeAuthenticationResponse {
  return FlightExchangeAuthenticationResponseToJSONTyped(json, false);
}

export function FlightExchangeAuthenticationResponseToJSONTyped(
  value?: FlightExchangeAuthenticationResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    exchange_id: value["exchangeId"],
    authentication_id: value["authenticationId"],
    provider: value["provider"],
    test: value["test"],
    status: value["status"],
    reason_code: value["reasonCode"],
    expires_at:
      value["expiresAt"] == null
        ? value["expiresAt"]
        : value["expiresAt"].toISOString(),
    action: FlightExchangeAuthenticationActionToJSON(value["action"]),
    can_confirm: value["canConfirm"],
  };
}
